declare let window: any;

const HUBSPOT_SCRIPT_LOADER_ID = 'hs-script-loader';

let loadGeneration = 0;
let pendingOnReady: (() => void) | null;

export interface HubSpotWidgetConfiguration {
  identificationEmail: string;
  identificationToken: string;
  portalId: string;
}

function removePendingOnReady(): void {
  if (!pendingOnReady || !Array.isArray(window.hsConversationsOnReady)) {
    pendingOnReady = null;
    return;
  }

  const callbackIndex = window.hsConversationsOnReady.indexOf(pendingOnReady);
  if (callbackIndex !== -1) {
    window.hsConversationsOnReady.splice(callbackIndex, 1);
  }

  pendingOnReady = null;
}

export function clearHubSpotWidget(): void {
  loadGeneration += 1;

  if (typeof window === 'undefined' || typeof document === 'undefined') {
    return;
  }

  if (window.HubSpotConversations) {
    window.HubSpotConversations.clear({resetWidget: true});
  }

  removePendingOnReady();

  const scriptLoader = document.getElementById(HUBSPOT_SCRIPT_LOADER_ID);
  if (!window.HubSpotConversations && scriptLoader && scriptLoader.parentNode) {
    scriptLoader.parentNode.removeChild(scriptLoader);
  }

  window.hsConversationsSettings = {
    loadImmediately: false
  };
}

export function initializeHubSpotWidget(
  configuration: HubSpotWidgetConfiguration,
  onReady: () => void
): void {
  clearHubSpotWidget();

  if (typeof window === 'undefined' || typeof document === 'undefined') {
    return;
  }

  window.hsConversationsSettings = {
    loadImmediately: false,
    identificationEmail: configuration.identificationEmail,
    identificationToken: configuration.identificationToken
  };

  const currentLoadGeneration = loadGeneration;
  const guardedOnReady = () => {
    if (currentLoadGeneration !== loadGeneration || !window.HubSpotConversations) {
      return;
    }

    removePendingOnReady();
    window.HubSpotConversations.widget.load();
    onReady();
  };

  if (window.HubSpotConversations) {
    guardedOnReady();
    return;
  }

  window.hsConversationsOnReady = window.hsConversationsOnReady || [];
  pendingOnReady = guardedOnReady;
  window.hsConversationsOnReady.push(guardedOnReady);

  const script = document.createElement('script');
  script.id = HUBSPOT_SCRIPT_LOADER_ID;
  script.async = true;
  script.defer = true;
  script.src = `https://js.hs-scripts.com/${encodeURIComponent(configuration.portalId)}.js`;
  document.body.appendChild(script);
}
